import React, { useEffect, useState } from "react";


const NewPlaceAutocomplete = () => {
  const [address, setAddress] = useState("");
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadScripts = async () => {
      // Load Google Maps API
      if (!document.getElementById("google-maps")) {
        const mapsScript = document.createElement("script");
        mapsScript.id = "google-maps";
        mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBInBX0v0jwVCHrTnXOh0xE6jMTtGogL_M&libraries=places&v=beta`;
        mapsScript.async = true;
        document.body.appendChild(mapsScript);
        await new Promise((resolve) => (mapsScript.onload = resolve));
      }

      // Load the new web component definition (important!)
      if (!document.getElementById("place-autocomplete-lib")) {
        const libScript = document.createElement("script");
        libScript.id = "place-autocomplete-lib";
        libScript.type = "module";
        libScript.src =
          "https://unpkg.com/@googlemaps/extended-component-library@0.6/dist/esm/place_autocomplete.js";
        document.body.appendChild(libScript);
        await new Promise((resolve) => (libScript.onload = resolve));
      }

      initAutocomplete();
    };

    loadScripts();
  }, []);

  const initAutocomplete = () => {
    const el = document.querySelector("gmpx-place-autocomplete");
    if (!el) return;

    el.addEventListener("gmpx-placechange", async () => {
      const place = await el.getPlace();
      if (!place?.addressComponents) return;
      parseAddress(place);
    });
  };

  const parseAddress = (place) => {
    const c = place.addressComponents || [];
    const get = (t) => c.find((x) => x.types.includes(t))?.longText || "";

    setAddress(place.formattedAddress);
    setDetails({
      area: get("sublocality") || get("neighborhood") || "",
      city: get("locality") || get("administrative_area_level_2") || "",
      state: get("administrative_area_level_1"),
      country: get("country"),
      pincode: get("postal_code"),
    });
  };

  const handleUseMyLocation = async () => {
    if (!navigator.geolocation) return alert("Not supported");

    setLoading(true);
    navigator.geolocation.getCurrentPosition(async (pos) => {
      const { latitude, longitude } = pos.coords;
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBInBX0v0jwVCHrTnXOh0xE6jMTtGogL_M`
      );
      const data = await res.json();
      if (data.results?.length) {
        const r = data.results[0];
        const comp = r.address_components.map((c) => ({
          longText: c.long_name,
          types: c.types,
        }));
        parseAddress({ formattedAddress: r.formatted_address, addressComponents: comp });
      }
      setLoading(false);
    });
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-2xl shadow-md space-y-4">
      <h2 className="text-lg font-semibold text-gray-800">Select Your Location</h2>

      {/* 🏙️ Fixed manual search field */}
      <gmpx-place-autocomplete
        placeholder="Search area, city, or pincode"
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ddd",
        }}
      ></gmpx-place-autocomplete>

      <div className="flex justify-center">
        <button
          onClick={handleUseMyLocation}
          disabled={loading}
          className="bg-[#f4a406] text-white px-5 py-2 rounded-lg font-medium hover:bg-[#e09a0c] transition-all disabled:opacity-60"
        >
          {loading ? "Detecting..." : "📍 Use My Location"}
        </button>
      </div>

      {address && (
        <div className="bg-gray-50 border rounded-lg p-4 text-sm text-gray-700">
          <p className="font-semibold text-gray-800 mb-2">Selected Address</p>
          <p>{address}</p>
          <div className="grid grid-cols-2 gap-y-1 mt-3 text-xs">
            <p><strong>Area:</strong> {details.area}</p>
            <p><strong>City:</strong> {details.city}</p>
            <p><strong>State:</strong> {details.state}</p>
            <p><strong>Pincode:</strong> {details.pincode}</p>
            <p className="col-span-2"><strong>Country:</strong> {details.country}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewPlaceAutocomplete;
